// Macht aus Markdown lesbaren Fliesstext - fuer Belege aus dem Wissensdienst.
//
// Pohls Kapitel sind Markdown. Im Beleg stand "## Verlaengerung
// **Paragraf:** …", und die Zeichen lenkten vom Inhalt ab. Umgewandelt wird
// nur, was eindeutig Markdown ist: Ein senkrechter Strich mitten im
// Vertragstext ("Kirsten und Klein GbR | EN:POWER") bleibt, nur Zeilen, die
// mit "|" beginnen, gelten als Tabelle.

const TABELLEN_TRENNZEILE = /^\s*\|?\s*:?-{3,}:?\s*(\|\s*:?-{3,}:?\s*)*\|?\s*$/;

function tabellenzeile(zeile) {
  if (!/^\s*\|/.test(zeile)) return zeile;
  return zeile
    .trim()
    .replace(/^\|\s*|\s*\|$/g, '')
    .split(/\s*\|\s*/)
    .join(' · ');
}

export function ohneMarkdown(text) {
  return String(text ?? '')
    .split('\n')
    .filter((zeile) => !TABELLEN_TRENNZEILE.test(zeile))
    .map(tabellenzeile)
    .join('\n')
    .replace(/^\s{0,3}#{1,6}\s+/gm, '')
    .replace(/^\s*>\s?/gm, '')
    // Verweise: nur der Text. Pohls Kapitel verlinken aufeinander.
    .replace(/\[([^\]\n]+)\]\([^)\s]*\)/g, '$1')
    // Nur Sternchen, keine Unterstriche: "____" ist im Vertrag eine
    // Unterschriftslinie, und Pohls Kapitel nutzen ohnehin "**" und "*".
    .replace(/\*\*(.+?)\*\*/g, '$1')
    // Ein uebrig gebliebenes "**" stammt aus einem abgeschnittenen Text.
    .replace(/\*\*/g, '')
    // Kursiv nur, wenn das Sternchen am Wort klebt: "2 * 5" bleibt stehen.
    .replace(/(^|[\s(„"])\*(?=\S)([^*\n]*?\S)\*(?=$|[\s).,;:!?“"])/gm, '$1$2')
    .replace(/`([^`\n]*)`/g, '$1')
    .trim();
}
